/** Production API + web (used when REACT_APP_* env vars are missing during build). */
const PRODUCTION_BACKEND = "https://apiuitvoering.config-go.com";
const PRODUCTION_APP = "https://uitvoering.config-go.com";

const isProdBuild = process.env.NODE_ENV === "production";

/** FastAPI origin (no trailing slash). Override with REACT_APP_BACKEND_URL in .env.production */
export const BACKEND_ORIGIN = (
  process.env.REACT_APP_BACKEND_URL ||
  (isProdBuild ? PRODUCTION_BACKEND : "http://localhost:8000")
).replace(/\/$/, "");

/** API base path, e.g. https://apiuitvoering.config-go.com/api */
export const API = `${BACKEND_ORIGIN}/api`;

/**
 * Public URL where this SPA is served (no trailing slash).
 * Set REACT_APP_PUBLIC_APP_URL in `.env.production` for online builds.
 */
export const APP_PUBLIC_ORIGIN = String(
  process.env.REACT_APP_PUBLIC_APP_URL ||
    (isProdBuild ? PRODUCTION_APP : ""),
).replace(/\/$/, "");

/** Avoid stale GET responses behind browser / reverse-proxy caches (orders + signatures). */
export const AXIOS_SKIP_HTTP_CACHE = {
  headers: {
    "Cache-Control": "no-cache",
    Pragma: "no-cache",
  },
};
